import { ReactComponent as Eyeclose } from "@/assets/images/eyeclose.svg";
import { EyeOutlined } from "@ant-design/icons";

const PasswordEye = (visible: boolean) =>
  visible ? (
    <EyeOutlined style={{ fontSize: "16px", color: "#797D8B" }} />
  ) : (
    <span style={{ cursor: "pointer", color: "#797D8B" }}>
      <Eyeclose />
    </span>
  );

export default PasswordEye;
